module.exports = __webpack_public_path__ + "media/images/pets3-3cc6c9c2a064b9a089862baa1b1901ab.jpg";